import React from "react";
import { MultiToc, SideDrawerOption } from "./components";

export default function Drawer({ open, onOpen, infiniteListRequest }) {
	return (
		<>
			<SideDrawerOption open={open} onOpen={onOpen} />
			<MultiToc infiniteListRequest={infiniteListRequest} open={open} />
		</>
	);
}
